import React from 'react';
import { RouteComponentProps, Redirect } from 'react-router';
import Locale from 'localization/Localization';
import { PublicLayout } from 'components/public/PublicLayout';
import { Spinner } from 'components/common/Spinner';
import { AppServices } from 'services/AppServices';
import queryString from 'query-string';

interface ExternalLoginQuery {
	access_token?: string;
	refresh_token?: string;
	expires_in?: number;
}

interface ExternalLoginPageState {
	checkIsFinished: boolean;
	checkResult: boolean;
	params: ExternalLoginQuery;
}

export class ExternalLoginPage extends React.Component<RouteComponentProps<{}>, ExternalLoginPageState>
{
	private static defaultRedirectPath = '/home';

	constructor(props: RouteComponentProps<{}>) {
		super(props);

		const query = queryString.parse(this.props.location.search) as object;
		const params = query as ExternalLoginQuery;

		this.state = {
			checkIsFinished: false,
			checkResult: false,
			params: params
		};
	}

	public componentDidMount() {
		document.title = Locale.getPageTitle('page_login');

		if (this.state.params === undefined || this.state.params.access_token === undefined) {
			this.setState({ checkIsFinished: true, checkResult: false });
			return;
		}

		AppServices.loginService.externalAuthentication(
			this.state.params.access_token,
			this.state.params.refresh_token || '',
			this.state.params.expires_in || 3600)
			.then((ok: boolean) => {
				this.setState({
					checkIsFinished: true,
					checkResult: ok
				});
			}
			).catch((reason: any) => {
				console.log(reason);
				this.setState({
					checkIsFinished: true,
					checkResult: false
				});
			});
	}

	public render() {
		if (this.state.checkIsFinished) {
			if (this.state.checkResult) {
				return <Redirect to={ExternalLoginPage.defaultRedirectPath} />;
			}
			else {
				return <Redirect to={'/login'} />
			}
		}
		else {
			return <PublicLayout><Spinner /></PublicLayout>;
		}
	}
}